import React from "react";
import CircleLoader from "react-loader-spinner";
import { Typography } from 'antd';
const { Text } = Typography;
const Loader = (props) => {
    return (
        <div className='loader'>
            <CircleLoader 
                type="Circles"
                // color="#42307D"
                height={60}
                width={60}
                visible={true}
            />
            {/* <p>Please wait...</p>  */}
            <Text >
                Please wait...
            </Text>
        </div>
    )
}

export default Loader;